import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { ClaimBO } from './claim-edit/cliam-edit.model';
import { SaveBatchFileBO } from './claims.model';

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }

  getLovType(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getPayerList(): Observable<any> {
    let url = "api/Claims/GetPayerList?";
    return this.http.get(url, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getCompanyList(): Observable<any> {
    let url = "api/Claims/GetCompanyList?";
    return this.http.get(url, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getServiceList(): Observable<any> {
    let url = "api/Claims/GetServiceList?";
    return this.http.get(url, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getClearingHouseList(): Observable<any> {
    let url = "api/Claims/GetClearingHouseList?";
    return this.http.get(url, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getBatchFileTstring(params: URLSearchParams): Observable<any> {
    let url = "api/Claims/getEdi837String?";
    return this.http.get(url + params, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getServicedropDown(): Observable<any> {
    let url = "api/Service/GetServiceDropdown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}
